import { useState } from 'react'
import Modal from '..'
import DefaultButton from '../../Button/Button'
import FormInput from '../../Input'
import ModalClose from '../ModalClose'
import { useFormik } from 'formik'
import { twofaCodeLoginSchema } from '../../../validations/staffForm'
import { IcodeLoginFormModal, TwofaCodeLogin } from '../../../interfaces/staff'
import { showToast } from '../../../utils/toast'
import { authCall, endpoints } from '../../../api'
import { setLocals } from '../../../utils/local'
import { useLocation, useNavigate } from 'react-router-dom'
import usePermission from '../../../hooks/usePermission'
import { TwoFaLoginResponse } from '../../../interfaces/login'

const CodeLoginFormModal = ({
  open,
  setIsOpen,
  loading,
  setIsloading,
  onSuccess,
}: IcodeLoginFormModal) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { getDefaultRoute } = usePermission()
  const redirectPath = location?.state?.from
  const [initialValues] = useState({
    code: '',
  })

  const formik = useFormik({
    initialValues,
    validationSchema: twofaCodeLoginSchema,
    onSubmit: (data) => {
      if (loading) return

      const { code } = data
      let twoFaData: TwofaCodeLogin = { code }
      setIsloading(true)
      authCall<TwoFaLoginResponse>({
        url: endpoints.login2fa,
        data: twoFaData,
        method: 'post',
      })
        .then((data) => {
          setLocals({
            token: data.tokens.access.token,
            refreshToken: data.tokens.refresh.token,
            user: data.user,
            isLoggedIn: true,
          })
          const route = getDefaultRoute(data.user.permissions)
          navigate(redirectPath || route, { replace: true })
          formik.resetForm()
          onSuccess()
        })
        .catch((err) => {
          showToast({
            id: 'login-error',
            title: 'Login error',
            description: err.message,
            status: 'error',
          })
        })
        .finally(() => {
          setIsloading(false)
        })
    },
  })

  const handleStepper = () => {
    if (loading || !formik.dirty || !formik.isValid) {
      return
    }
    formik.handleSubmit()
  }

  return (
    <Modal
      open={open}
      close={() => setIsOpen(false)}
      modalClassName="flex flex-col !rounded-10"
      widthClass="w-[calc(100%-32px)] sm:max-w-lg"
    >
      <ModalClose onClick={() => setIsOpen(false)} />
      <div>
        <form onSubmit={formik.handleSubmit} className="mb-4">
          <h4 className="font-bold text-base sm:text-lg mb-4 sm:mb-6">Enter Secret Code</h4>
          <div className="flex flex-col gap-6 sm:gap-10">
            <FormInput
              placeholder="Enter code"
              type="text"
              label="Code:"
              name="code"
              onChange={formik.handleChange}
              value={formik.values.code}
            />
          </div>
        </form>
        <div className="mt-4 sm:mt-6 flex justify-end">
          <DefaultButton
            onClick={handleStepper}
            isLoading={loading}
            loadingText="Submitting..."
            disabled={loading || !formik.dirty || !formik.isValid}
            className="w-full sm:w-auto"
          >
            Submit
          </DefaultButton>
        </div>
      </div>
    </Modal>
  )
}

export default CodeLoginFormModal
